import { useEffect, useState } from "react";
import { useFilter } from "../../../../hooks/useFilter";
import "../styles.css"
import axios from "../../../../services/axios";

export function InfoBatches() {
    const {
        batchCategory,
        farmFilter,
        areasIdsFilter
    } = useFilter();

    const [adjustments, setAdjustments] = useState(0);
    const [balanceTotal, setBalanceTotal] = useState<number | null>(null);

    useEffect(() => {
        if (farmFilter)
            axios.get(`/adjustments?farmId=${farmFilter?.id}&${areasIdsFilter.length > 0 ? areasIdsFilter.map(area => `areaIds=${area.value}`).join("&") : ""}`)
                .then(({ data }) => {
                    setAdjustments(data.reduce((sum: number, adjustment: any) => sum + adjustment.balance, 0));
                })
    }, [farmFilter, areasIdsFilter]);

    useEffect(() => {
        setBalanceTotal(batchCategory?.content.reduce(
            (sum, batch) =>
                sum +
                batch.categories.reduce((batchSum, category) => batchSum + category.quantity, 0),
            0
        ))
    }, [batchCategory]);

    return (
        <section className="dashBoardInfo__container" style={{ marginTop: 30 }}>

            <div className="dashBoardInfoSplited__owner--container">
                <small>Ajuste atual</small>
                <h6 className={adjustments && adjustments <= 0 ? "dashBoardAdjustment__negative" : "dashBoardAdjustment__positive"}>{adjustments || 0}</h6>
            </div>

            <div className="dashBoardInfo__dark--container">
                <small>Saldo previsto</small>
                <h6>{(balanceTotal || 0) - (adjustments || 0)}</h6>
            </div>

        </section>
    );
}